import React from 'react';

const Pay = () => {
    return (
        <div className="text-center mt-5 pt-5">
            <h1>Payment system coming soon...</h1>
        </div>
    );
};

export default Pay;